import React from "react";

import "./App.css";
import "./css/component.css";
import ProjectRoutes from "./routes/ProjectRoutes";

function App() {
    return <ProjectRoutes / > ;
}

export default App;